// Styles
import "./assets/styles/_app.scss";

// Slider
import "slick-carousel";


$(document).ready(() => {
    require("./assets/scripts/jquery.fsscroll.min");
    require("./assets/scripts/ion.rangeSlider.min")
    require("./assets/scripts/main");
    require("./assets/scripts/forms");
    require("./assets/scripts/customSize");
    require("./assets/scripts/navigation");
    require("./assets/scripts/gsapScroll");
    require("./assets/scripts/modelGallery");
});